export const formatCurrency = (value: number, decimalCount = 2): string =>
  (value / 100).toFixed(decimalCount).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

/** "$25.00" / "-$25.00": like formatCurrency, but signed, with the sign before the currency symbol. */
export const formatSignedCurrency = (value: number, currencySymbol = "$"): string =>
  `${value < 0 ? "-" : ""}${currencySymbol}${formatCurrency(Math.abs(value))}`;
